import { Box, Button, Dialog, Typography } from "@mui/material";
import { blue, grey, indigo } from "../../colors";
import { getDomainLabel } from "./domainMeta";

type DomainSwitchModalProps = {
  open: boolean;
  fromRole: string;
  toRole: string;
  onLogout: () => void;
  onCancel: () => void;
};

/**
 * Shown when a multi-domain user picks a different domain from the top-bar dropdown.
 *
 * For compliance reasons, the user must log out and log back in, then re-pick on the
 * Welcome page. The primary action is therefore Logout.
 */
const DomainSwitchModal = ({ open, fromRole, toRole, onLogout, onCancel }: DomainSwitchModalProps): JSX.Element => {
  const fromLabel = getDomainLabel(fromRole);
  const toLabel = getDomainLabel(toRole);

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" sx={{ "& .MuiPaper-root": { borderRadius: "16px" } }}>
      <Box sx={{ p: 4, minWidth: { xs: "auto", sm: "420px" } }}>
        <Typography sx={{ fontSize: "20px", fontWeight: 700, color: indigo[900] }}>Switch workspace?</Typography>
        <Typography sx={{ mt: 1.5, fontSize: "14px", color: grey[700], lineHeight: 1.6 }}>
          To switch from <b>{fromLabel}</b> to <b>{toLabel}</b> you need to log out and log back in, then choose{" "}
          {toLabel} on the welcome page.
        </Typography>

        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1.5, mt: 3 }}>
          <Button
            onClick={onCancel}
            sx={{ textTransform: "none", color: grey[700], fontWeight: 600, borderRadius: "8px", px: 2 }}
          >
            Cancel
          </Button>
          <Button
            onClick={onLogout}
            variant="contained"
            disableElevation
            sx={{
              textTransform: "none",
              fontWeight: 700,
              borderRadius: "8px",
              px: 2.5,
              backgroundColor: blue[700],
              "&:hover": { backgroundColor: blue[800] },
            }}
          >
            Logout
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};

export default DomainSwitchModal;
